'use client';
import React from 'react';
import { getAssetUrl } from '@utils/getAssetUrl';
import GardeniaContainer from '../GardeniaContainer';
import cn from './style.module.scss';

export default function GardeniaLaunchConclusion(props: any) {
  const { t } = props;
  return (
    <section className={cn.launchGRDConclusion}>
      <div className={cn.conclusionGRDImage}>
        <img src={props.refinedStoryImg.url} alt={props.refinedStoryImg.alt} />
      </div>
      <div className={cn.conclusionGRDContent}>
        <GardeniaContainer>
          <div className={cn.conclusionGRDText}>
            <div className={cn.conclusionGRDText__element}>
              <h2>{t['yasConclusionHeading']}</h2>
              <p>{t['yasConclusionContent']}</p>
            </div>
          </div>
        </GardeniaContainer>
      </div>
    </section>
  );
}
